exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.comments[data-v-74d1caa6] {\n\twidth:20%;\n}\n.saving[data-v-74d1caa6] {\n\tfont-size: 10px;\n\tcolor: gray;\n\ttext-decoration: underline;\n\talign-self: flex-end;\n\tmargin-left:5px;\n\tmargin-bottom:0px;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-74d1caa6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/view/Scheduling_V2.vue
// module id = 585
// module chunks = 0